import type { TmjSlot } from "@/lib/tmj/types";

export function addDays(key: string, days: number) {
  const date = new Date(`${key}T12:00:00Z`);
  date.setUTCDate(date.getUTCDate() + days);
  return date.toISOString().slice(0, 10);
}
export function monday(key: string) {
  return addDays(key, -((new Date(`${key}T12:00:00Z`).getUTCDay() + 6) % 7));
}
export function weekNumber(key: string) {
  const year = new Date(`${addDays(key, 3)}T12:00:00Z`).getUTCFullYear();
  return 1 + Math.round((Date.parse(`${key}T12:00:00Z`) - Date.parse(`${monday(`${year}-01-04`)}T12:00:00Z`)) / 604800000);
}
export function calendarDays(from: string, slots: TmjSlot[]) {
  const dateKey = (value: number) => new Intl.DateTimeFormat("sv-SE", { timeZone: "Europe/Budapest" }).format(value);
  // Keep weekend appointments visible when the therapist offers them.
  const count = slots.some(row => dateKey(row.startAt) >= addDays(from, 5)) ? 7 : 5;
  return Array.from({ length: count }, (_, index) => {
    const key = addDays(from, index);
    const date = new Date(`${key}T12:00:00Z`);
    return { key, date,
      shortLabel: date.toLocaleDateString("hu-HU", { weekday: "short", timeZone: "Europe/Budapest" }),
      dateLabel: date.toLocaleDateString("hu-HU", { month: "short", day: "numeric", timeZone: "Europe/Budapest" }),
      slots: slots.filter(row => dateKey(row.startAt) === key) };
  });
}
